module.exports = __webpack_public_path__ + "static/media/Rightnav.bd6b06e2.svg";